import { render, staticRenderFns } from "./main-summary.vue?vue&type=template&id=d977dd86&"
import script from "./main-summary.vue?vue&type=script&lang=js&"
export * from "./main-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports